module.exports = __webpack_public_path__ + "static/media/logo-printrelitere.d5ddca07.png";